import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

const getAll = (params) =>
  axios.get(`/template-versions?${getQueryString(params)}`);

const create = (data) => axios.post("/template-versions", data);

const update = (templateVersionId, data) =>
  axios.put(`/template-versions/${templateVersionId}`, data);

const remove = (templateVersionId) =>
  axios.delete(`/template-versions/${templateVersionId}`);

const removeHard = (templateVersionId) =>
  axios.delete(`/template-versions/remove-hard/${templateVersionId}`);

const templateVersionService = {
  getAll,
  create,
  update,
  remove,
  removeHard,
};

export default templateVersionService;
